import MsgTargetSetDialog from './MsgTargetSetDialog';

export default MsgTargetSetDialog;
